import { Menu } from '@base-ui/react/menu'
import { Check } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { listItemCheck } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface MenuRadioItemIndicatorProps extends PartProps<Menu.RadioItemIndicator.Props> {
  className?: string
}

/** The trailing check, the same mark Select draws on its chosen row. Defaults to a check icon. */
function MenuRadioItemIndicator({ className, children, ...props }: MenuRadioItemIndicatorProps) {
  return (
    <Menu.RadioItemIndicator data-slot="list-item-check" className={twMerge(listItemCheck, className)} {...props}>
      {children ?? <Check />}
    </Menu.RadioItemIndicator>
  )
}

export { MenuRadioItemIndicator }
